theme.headerSticky = (function() {
  function ScrollSticky(e){
    const headerStickyWrapper = document.querySelector('header');
    const headerStickyTarget = document.querySelector('.header__sticky');
    
    if(headerStickyTarget){
      const stickyThreshold = headerStickyWrapper.getBoundingClientRect().top + window.scrollY;
      window.addEventListener('scroll', function(){
        if(window.scrollY >= stickyThreshold){
          headerStickyTarget.classList.add('sticky');
        } else{
          headerStickyTarget.classList.remove('sticky');
        }
      })
    }
    
    
  }
  return ScrollSticky;
})();

